import styles from './Trials.module.css';

import config from 'config.js';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format, formatDistanceToNow } from 'date-fns';
import { Link } from 'react-router-dom';
import { Statistic, Card, Row, Col, Spin, PageHeader, Button, Tooltip, List, Avatar, Tag, Rate, Descriptions } from 'antd';

import { ReloadOutlined } from '@ant-design/icons';

const Trials = () => {
  const [trials, setTrials] = useState([]);

  const getTrialsData = async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/root/trials`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      setTrials(response.data);

      return response.data;
    } catch (value) {
      return [];
    }
  };

  const reload = () => {
    getTrialsData();
  };

  useEffect(() => {
    reload();
  }, []);

  console.log({ trials });

  return (
    <>
      <PageHeader
        title="Trials"
        extra={[
          <Button onClick={() => reload()} key="reload">
            <ReloadOutlined />
          </Button>
        ]}
        style={{ border: '1px solid #f0f0f0', background: '#fff', margin: '0 0 15px 0' }}
      />

      <Card style={{ width: '100%' }}>
        {trials.map((user) => (
          <Card
            type="inner"
            style={{ margin: '0 0 30px 0' }}
            title={
              <>
                <Avatar
                  shape="square"
                  style={{ margin: '0 10px 0 0' }}
                  src={`https://d3djdih2k2vfi2.cloudfront.net/avatars/${user._id}/${user._id}.png?hash=${user.avatar}`}>
                  {!user.avatar && (user.name || user.email || '').charAt(0).toUpperCase()}
                </Avatar>
                <Link to={`/users/${user._id}`}>{user.email}</Link>
              </>
            }
            extra={
              <>
                {formatDistanceToNow(new Date(user.billing.trialEnd))} of trial left
                <Rate disabled allowHalf={true} defaultValue={user.score} style={{ margin: '0 0 0 20px' }} />
              </>
            }>
            <Descriptions bordered size="small">
              <Descriptions.Item label="Name">
                {user.firstName} {user.lastName}
              </Descriptions.Item>
              <Descriptions.Item label="Company">{user.companyName}</Descriptions.Item>
              <Descriptions.Item label="Country">{user.country}</Descriptions.Item>
              <Descriptions.Item label="Verified">{user.verified}</Descriptions.Item>
              <Descriptions.Item label="Trial emails">{user.trialEmails.join(', ')}</Descriptions.Item>
            </Descriptions>
          </Card>
        ))}
      </Card>
    </>
  );
};

export default Trials;
